import { inject } from '@angular/core';
import { Router, type ActivatedRouteSnapshot, type CanActivateFn } from '@angular/router';
import { toObservable } from '@angular/core/rxjs-interop';
import { filter, map, take } from 'rxjs';
import type { FeatureKey } from '@zag/licensing/common';
import { EntitlementsService } from '../services/entitlements.service';

/**
 * Blocks routes of unlicensed modules (route `data: { feature: '<key>' }`).
 * Waits for the entitlements resource to settle; unknown state fails open —
 * the server-side FeatureGuard is the real enforcement.
 */
export const featureGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const entitlements = inject(EntitlementsService);
  const router = inject(Router);
  const feature = route.data?.['feature'] as FeatureKey | undefined;
  if (!feature) {
    return true;
  }

  return toObservable(entitlements.entitlementsResource.status).pipe(
    filter(status => status !== 'loading' && status !== 'reloading'),
    take(1),
    map(() => (entitlements.hasFeature(feature) ? true : router.createUrlTree(['/dashboard'])))
  );
};
